<ul
  class="flex flex-col shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] bg-surface-magic dark:bg-surface-magic-darkmode border border-outline dark:border-outline-darkmode rounded-lg overflow-hidden"
>
  <ng-content />
</ul>
